// GENERATED FILE - DO NOT MODIFY

export enum GetOfficesSortColumnDto {
    Name = "Name",
    Address = "Address",
    IsUserDefaultOffice = "IsUserDefaultOffice",
}